import { combineReducers } from 'redux';

import { auth, IAuthState } from './Auth/reducer';
import { chartCounter, IChartCounterState } from './ChartCounter/reducer';
import { charts, IChartsState } from './Charts/reducer';
import { comments, ICommentsState } from './Comments/reducer';
import { favorites, IFavoritesState } from './Favorites/reducer';
import { IMyTeamState, myTeam } from './MyTeam/reducer';
import { ISharedSnapState, sharedSnap } from './SharedSnap/reducer';
import { ISnapshotsState, snapshots } from './Snapshots/reducer';
import { ITeamsState, teams } from './Teams/reducer';
import { IUserState, user } from './User/reducer';
import { applications, IApplicationsState } from './Applications/reducer';
import { IMineTeamRoomsState, mineTeamRooms } from './MineTeamRooms/reducer';
import {
	ISharedTeamRoomsState,
	sharedTeamRooms,
} from './SharedTeamRooms/reducer';
import { ISnapsState, snaps } from './Snaps/reducer';
import { IMembersState, members } from './Members/reducer';
import { IInvitesState, invites } from './Invites/reducer';

export interface IStore {
	auth: IAuthState;
	sharedSnap: ISharedSnapState;
	user: IUserState;
	myTeam: IMyTeamState;
	teams: ITeamsState;
	comments: ICommentsState;
	chartCounter: IChartCounterState;
	charts: IChartsState;
	snapshots: ISnapshotsState;
	favorites: IFavoritesState;
	applications: IApplicationsState;
	mineTeamRooms: IMineTeamRoomsState;
	sharedTeamRooms: ISharedTeamRoomsState;
	snaps: ISnapsState;
	members: IMembersState;
	invites: IInvitesState;
}

export const rootReducer = combineReducers<IStore>({
	auth,
	sharedSnap,
	user,
	myTeam,
	teams,
	comments,
	chartCounter,
	charts,
	snapshots,
	favorites,
	applications,
	mineTeamRooms,
	sharedTeamRooms,
	snaps,
	members,
	invites,
});
